import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { StorageService } from "../storage/storage.service";
@Injectable({ providedIn: "root" })
export class AuthGuardCommon implements CanActivate {
  constructor(private _router: Router, private storageService: StorageService) {
    // this.storageService.secureStorage.getItem("currentEmployee");
  }
  canActivate(): boolean {
    if (
      this.storageService.secureStorage.getItem("currentUser") == "AdminLogin" ||
      this.storageService.secureStorage.getItem("currentUser") == "AffiliateLogin" ||
      this.storageService.secureStorage.getItem("currentUser") == "EmployeeLogin" ||
      this.storageService.secureStorage.getItem("currentUser") == "ClientLogin" ||
      this.storageService.secureStorage.getItem("currentUser") == "MainAdminLogin" ||
      this.storageService.secureStorage.getItem("currentUser") == "SubAdminLogin"
    ) {
      return true;
    } else {
      this._router.navigate([""]);
      return false;
    }
  }
}
